import SketchAdminSketchOrderClient from '../lib/apiClients/roofSnapApiClient/sketchAdminSketchOrderClient';
import { CALL_API } from "../middleware/api";
import {
    GET_SKETCH_ORDER_FAILURE,
    GET_SKETCH_ORDER_REQUEST,
    GET_SKETCH_ORDER_SUCCESS,
    UPDATE_SKETCH_ORDER_FAILURE,
    UPDATE_SKETCH_ORDER_REQUEST,
    UPDATE_SKETCH_ORDER_SUCCESS,
    DELETE_SKETCH_ORDER_PROJECT_FAILURE,
    DELETE_SKETCH_ORDER_PROJECT_REQUEST,
    DELETE_SKETCH_ORDER_PROJECT_SUCCESS,
} from "./actionTypes";
import SketchTechSketchOrderClient from "../lib/apiClients/roofSnapApiClient/sketchTechSketchOrderClient";

const getSketchOrderClient = (getState) => {
    const {
            isAdmin,
            isSketchOsAdmin
    } = getState().currentUserRoles;
    // If the user is an admin or a sketch os admin, use the sketch orders endpoint
    // Otherwise, use the restricted orders endpoint
    if (isAdmin || isSketchOsAdmin) {
        return new SketchAdminSketchOrderClient('v2');
    } else {
        return new SketchTechSketchOrderClient('v2');
    }
}

const getSketchOrderRequest = (request, params) => {
    return {
        [CALL_API]: {
            types: [
                GET_SKETCH_ORDER_REQUEST,
                GET_SKETCH_ORDER_SUCCESS,
                GET_SKETCH_ORDER_FAILURE
            ],
            request,
            params,
        }
    }
};

export const getSketchOrder = (id) => {
    return (dispatch, getState) => {
        const sketchSketchOrderClient = getSketchOrderClient(getState);
        const request = sketchSketchOrderClient.getSketchOrder;
        const params = {
            id
        };
        return dispatch(getSketchOrderRequest(request, params));
    };
};

const updateSketchOrderRequest = (request, params) => {
    return {
        [CALL_API]: {
            types: [
                UPDATE_SKETCH_ORDER_REQUEST,
                UPDATE_SKETCH_ORDER_SUCCESS,
                UPDATE_SKETCH_ORDER_FAILURE
            ],
            request,
            params
        }
    }
};

export const updateSketchOrder = (id, body, version) => {
    return (dispatch, getState) => {
        const sketchSketchOrderClient = getSketchOrderClient(getState);
        const request = sketchSketchOrderClient.updateSketchOrder;
        const params = {
            id,
            body,
            version
        };
        return dispatch(updateSketchOrderRequest(request, params));
    };
};

const deleteSketchOrderProjectRequest = (request, params) => {
    return {
        [CALL_API]: {
            types: [
                DELETE_SKETCH_ORDER_PROJECT_REQUEST,
                DELETE_SKETCH_ORDER_PROJECT_SUCCESS,
                DELETE_SKETCH_ORDER_PROJECT_FAILURE,
            ],
            request,
            params
        }
    }
};
export const deleteSketchOrderProject = (id, version) => {
    return (dispatch, getState) => {
        const sketchSketchOrderClient = getSketchOrderClient(getState);
        const request = sketchSketchOrderClient.deleteSketchOrderProject;
        const params = {
            id
        };
        return dispatch(deleteSketchOrderProjectRequest(request, params));
    };
};